module.exports = __webpack_public_path__ + "media/images/guideline/E01-ae9523e86fd2b498608a559ab49c18e7.jpg";